<template>
  <div v-html="headerHTML"></div>
</template>

<script>
  import {getFoot} from "../../plugins/header";

  export default {
    name: 'TheFooter',
    data() {
      return {
        headerHTML: "",
      };
    },
    mounted() {
      this.getFooter();
    },
    methods: {
      async getFooter() {
        const res = await getFoot();

        let reg = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
        let linkReg = /<link\s+[^>]*?href\s*=\s*["'][^"']*?["'][^>]*?>/gi
        // .replace(linkReg, '');
        this.headerHTML = res
        let result = res.match(reg);
        let scriptText = [];
        let scriptList = [];
        result && result.forEach((item, i) => {
          if (item.substring(0, 100).indexOf("src=") !== -1) {
            var reg3 = /<script.*?src="(.*?)".*?\/?>/i;
            const url = item.match(reg3)[1];
            scriptList.push(url);
          } else {
            var reg2 = /<script>([\s\S]*?)<\/script>/;
            const textMatch = item.match(reg2);
            textMatch && scriptText.push(item.match(reg2)[1]);
          }
        });
        let notWantScriptUrl = ["https://singapore-1312056779.cos.accelerate.myqcloud.com/site_style/js/contactus.js", 'https://singapore-1312056779.cos.accelerate.myqcloud.com/site_style/js/cookie_2022.js']
        scriptList.forEach((text) => {
          if (notWantScriptUrl.includes(text)) return;
          let script = document.createElement("script");
          script.type = "text/javascript";
          script.src = text;
          document.getElementsByTagName("head")[0].appendChild(script);
        });
        [
          "https://singapore-1312056779.cos.accelerate.myqcloud.com/site_style/js/contactus.js",
          "/static/footer.js"
        ].forEach(this.addScript)

      },
      addScript(src) {
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = src
        document.getElementsByTagName('head')[0].appendChild(script)
      }
    },
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/layout/TheFooter.vue